// TODO: Extract font families from the API.
export const FONT_FAMILY_COMBINATIONS = {
  fontFamilyCombination1: {
    font_family_header: "'Spectral', serif",
    font_family_paragraph: "'B612', sans-serif",
  },
  fontFamilyCombination2: {
    font_family_header: "'Vollkorn', serif",
    font_family_paragraph: "'Montserrat', sans-serif",
  },
};
